var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useState } from 'react';
import { Modal } from 'antd';
import { IconJSclose, IconWinLeft, IconWinRight } from './../IconFont';
export default function ImagePreview(props) {
    var type = props.type, visible = props.visible, _a = props.width, width = _a === void 0 ? '90%' : _a, _b = props.height, height = _b === void 0 ? 'auto' : _b, title = props.title, modalClassName = props.modalClassName, onCancelType = props.onCancelType, onOkType = props.onOkType, onCancel = props.onCancel, onOk = props.onOk, data = props.data;
    var _c = useState((data && data.currentIndex) || 0), currentIndex = _c[0], setCurrentIndex = _c[1];
    function clickHandle(flag) {
        if (flag) {
            // ++
            if (data && data.imageList.length - 1 > currentIndex) {
                setCurrentIndex(currentIndex + 1);
            }
        }
        else {
            if (data && currentIndex > 0) {
                setCurrentIndex(currentIndex - 1);
            }
        }
    }
    function Guide(_a) {
        var flag = _a.flag, styles = _a.styles;
        return (React.createElement("div", { style: __assign({ position: 'absolute', display: 'flex', width: 55, height: 55, borderRadius: '50%', background: '#1C1C1C', color: '#fff', alignItems: 'center', justifyContent: 'center', fontSize: 16, cursor: 'pointer' }, styles), onClick: function () { return clickHandle(flag); }, className: "guide" }, flag ? IconWinRight : IconWinLeft));
    }
    return (React.createElement(Modal, { className: "me-image-preview-common-modal " + (modalClassName || ''), onCancel: onCancel, width: "100%", visible: visible, bodyStyle: {
            padding: 0,
        }, title: title, footer: null, closeIcon: IconJSclose },
        React.createElement("div", { style: {
                height: '100%',
                boxSizing: 'content-box',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                position: 'relative',
            } },
            React.createElement(Guide, { flag: false, styles: {
                    left: 80,
                    opacity: currentIndex === 0 ? 0.5 : 1,
                } }),
            React.createElement("div", { style: {
                    width: '100%',
                    textAlign: 'center',
                } }, data && data.imageList.length ? (React.createElement("img", { style: {
                    maxWidth: '90%',
                }, src: data.imageList[currentIndex] })) : null),
            React.createElement(Guide, { flag: true, styles: {
                    right: 80,
                    opacity: data && data.imageList && data.imageList.length - 1 === currentIndex
                        ? 0.5
                        : 1,
                } }))));
}
//# sourceMappingURL=index.js.map